import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { TiempoComponent } from "./tiempo/tiempo.component";
import { CategoriaComponent } from "./categorias/categoria.component";
import { NominacionCardComponent } from "./nominacion-card/nominacion-card.component";
import { NominacionCarruselComponent } from "./nominacion-carrusel/nominacion-carrusel.component";
import { FiltroCategoriaComponent } from "./filtro-categoria/filtro-categoria.component";
import { PaginadorComponent } from "./paginador/paginador.component";
import { ModalVotarComponent } from "./modal-votar/modal-votar.component";
import { StepsNominacion } from "./steps-nominacion/steps-nominacion.component"
import { FormularioNominarComponent } from "./formulario-nominar/formulario-nominar.component";
import { ListadoCategoriasComponent } from "./listado-categorias/listado-categorias.component";
import { LogoEdicionComponent } from "./logo-edicion/logo-edicion.component";
import {
    AlertModule,
    BadgeModule,
    ButtonModule,
    CardModule,
    FormModule,
    GridModule,
    ModalModule,
    PopoverModule,
    ProgressModule,
    SharedModule,
    ToastModule,
    TooltipModule,
    UtilitiesModule
} from '@coreui/angular';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { AngularToastifyModule } from "angular-toastify";
import { IconModule } from "@coreui/icons-angular";
import { NgxEditorModule } from "ngx-editor";
import { NgSelectModule } from "@ng-select/ng-select";

@NgModule({
    declarations: [
        TiempoComponent,
        CategoriaComponent,
        NominacionCardComponent,
        NominacionCarruselComponent,
        FiltroCategoriaComponent,
        PaginadorComponent,
        ModalVotarComponent,
        StepsNominacion,
        FormularioNominarComponent,
        ListadoCategoriasComponent,
        LogoEdicionComponent
    ],
    imports: [
        CommonModule,
        AlertModule,
        BadgeModule,
        ButtonModule,
        CardModule,
        FormModule,
        GridModule,
        ModalModule,
        PopoverModule,
        ProgressModule,
        SharedModule,
        ToastModule,
        TooltipModule,
        UtilitiesModule,
        FormsModule,
        ReactiveFormsModule,
        AngularToastifyModule,
        IconModule,
        NgxEditorModule,
        NgSelectModule
    ],
    exports: [
        TiempoComponent,
        CategoriaComponent,
        NominacionCardComponent,
        NominacionCarruselComponent,
        FiltroCategoriaComponent,
        PaginadorComponent,
        ModalVotarComponent,
        StepsNominacion,
        FormularioNominarComponent,
        ListadoCategoriasComponent,
        LogoEdicionComponent
    ],
    providers: []
})

export class ComponentesModule { }